/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto
     */
    CountryCodeIso3166Alpha3: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto
     */
    CountryCurrencyCodeIso4217: string;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto
     */
    Lat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto
     */
    Lon?: number | null;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto {
    if (!('CountryCodeIso3166Alpha3' in value) || value['CountryCodeIso3166Alpha3'] === undefined) return false;
    if (!('CountryCurrencyCodeIso4217' in value) || value['CountryCurrencyCodeIso4217'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto {
    return FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'CountryCodeIso3166Alpha3': json['country_code_iso_3166_alpha_3'],
        'CountryCurrencyCodeIso4217': json['country_currency_code_iso_4217'],
        'Lat': json['lat'] == null ? undefined : json['lat'],
        'Lon': json['lon'] == null ? undefined : json['lon'],
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto {
    return FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country_code_iso_3166_alpha_3': value['CountryCodeIso3166Alpha3'],
        'country_currency_code_iso_4217': value['CountryCurrencyCodeIso4217'],
        'lat': value['Lat'],
        'lon': value['Lon'],
    };
}

